import React, { useContext } from 'react';
import { ThemeContext } from '../../Context';
import { ThemeOptions } from '../../publicSession/types';
var AvatarPlaceholder = function (_a) {
    var className = _a.className;
    var theme = useContext(ThemeContext);
    var imgSrc = theme === ThemeOptions.LIGHT
        ? 'https://st.deviantart.net/eclipse/icons/p07-light.svg?1'
        : 'https://st.deviantart.net/eclipse/icons/p07-dark.svg?1';
    return (React.createElement("div", { className: className },
        React.createElement("img", { src: imgSrc, alt: "" })));
};
AvatarPlaceholder.displayName = 'AvatarPlaceholder';
export default AvatarPlaceholder;
//# sourceMappingURL=AvatarPlaceholder.js.map